import { useMemo } from "react";
import type {
  DiscountVariantEnum,
  IncludedDiscountType,
  Maybe
} from "@shared/graphql.types";

export type ItemDiscounts = {
  codes?: string[];
  name: string;
  state?: string;
  type?: Maybe<DiscountVariantEnum>;
  value: number;
};

type SummaryDiscounts = {
  discounts: ItemDiscounts[];
  membershipDiscount: ItemDiscounts | undefined;
};

export const useGetDiscountsByType = (
  totalDiscountsByType: IncludedDiscountType[]
): SummaryDiscounts => {
  const itemDiscounts: SummaryDiscounts = useMemo(
    () =>
      totalDiscountsByType
        .filter((dic) => dic.type && !dic.type.match(/(shipping)|(gift)/i))
        .reduce(
          (acc: SummaryDiscounts, disc) => {
            if (disc.type === "membership") {
              acc.membershipDiscount = {
                codes: disc.code ? [disc.code] : undefined,
                name: disc.name,
                type: disc.type,
                value: disc.value
              };

              return acc;
            }

            if (disc.code) {
              const exist = acc.discounts.findIndex(
                ({ codes }) => codes?.length
              );
              if (exist >= 0) {
                const target = { ...acc.discounts[exist] };
                if (target.codes) target.codes.push(disc.code);
                acc.discounts[exist] = {
                  ...target,
                  value: target.value + disc.value
                };

                return acc;
              }
            } else {
              const exist = acc.discounts.findIndex(({ codes }) => !codes);
              if (exist >= 0) {
                const target = { ...acc.discounts[exist] };
                acc.discounts[exist] = {
                  ...target,
                  value: target.value + disc.value
                };

                return acc;
              }
            }

            acc.discounts.push({
              codes: disc.code ? [disc.code] : undefined,
              name: disc.name,
              type: disc.type,
              value: disc.value
            });
            return acc;
          },
          {
            discounts: [],
            membershipDiscount: undefined
          }
        ),
    [totalDiscountsByType]
  );

  return itemDiscounts;
};
